import { render, staticRenderFns } from "./ShipmentOrderQuery.vue?vue&type=template&id=2814de8b&scoped=true"
import script from "./ShipmentOrderQuery.vue?vue&type=script&lang=js"
export * from "./ShipmentOrderQuery.vue?vue&type=script&lang=js"
import style0 from "./ShipmentOrderQuery.vue?vue&type=style&index=0&id=2814de8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2814de8b",
  null
  
)

export default component.exports